import { defineMessages } from "react-intl";

export default defineMessages({
	createNewStartup: {
		defaultMessage: "Create new start-up",
	},
});
